/*
 * @Author: w
 * @Date: 2021-08-09 11:01:55
 * @LastEditors: w
 * @LastEditTime: 2021-12-27 11:57:38
 */
const productData = {
  productStatus: [
    { value: 2, label: '试卖' },
    { value: 1, label: '在售' },
    { value: 4, label: '促销' },
    { value: 3, label: '清仓' },
    { value: 5, label: '转季' },
    { value: 0, label: '停售' },
    { value: 6, label: '缺货' },
    { value: 7, label: '售罄' },
    { value: 8, label: '新品' },
  ],
  productStatusSpu: [
    { value: 0, label: '停售' },
    { value: 1, label: '在售' },
    { value: 2, label: '试卖' },
    { value: 3, label: '清仓' },
    { value: 4, label: '促销' },
    { value: 5, label: '转季' },
    { value: 6, label: '部分停售' },
    { value: 7, label: '部分在售' },
    { value: 8, label: '部分试卖' },
    { value: 9, label: '部分清仓 ' },
    { value: 10, label: '部分促销' },
    { value: 11, label: '部分转季' },
    { value: 12, label: '缺货' },
    { value: 13, label: '售罄' },
    { value: 14, label: '部分缺货' },
    { value: 15, label: '部分售罄' },
    { value: 16, label: '新品' },
    { value: 17, label: '部分新品' },
  ],
  statusTipsSku: [
    '试卖：采集产品，大量试款。不备货，缺一补一。',
    '在售：常规新品和热销品。备货',
    '新品：上架3个月内的新开款在售产品',
    '促销: 临时性的打折销售。备货（对应Listing部分清仓）',
    '清仓: 滞销品清仓，打折销售。不备货（对应Listing清仓）',
    '转季: 售完不再采购，下个销售周期会重新上架。不主动备货（对应Listing部分停售）',
    '缺货：供应商暂时性缺货产品，数据部统一备货，回货后调整回在售，不折扣（对应Listing部分转季）',
    '售罄：不备货，按库存销售，不折扣，售完转停售（对应Listing部分转季）',
    '停售：立即下架不再销售。'
  ],
  statusTipsSpu: [
    'SPU下SKU的状态个数=1，则与SKU状态一致',
    'SPU下有多个SKU状态时，',
    '优先级：清仓>停售>促销>转季>售馨>缺货>试卖>新品>在售',
    'SKU的状态个数>1且有清仓状态，“部分清仓”',
    'SKU的状态个数>1且有停售状态，“部分停售”',
    'SKU的状态个数>1且有促销状态，“部分促销”',
    'SKU的状态个数>1且有转季状态，“部分转季”',
    'SKU的状态个数>1且有售罄状态，“部分售罄”',
    'SKU的状态个数>1且有缺货状态，“部分缺货”',
    'SKU的状态个数>1且有试卖状态，“部分试卖”',
    'SKU的状态个数>1且有新品状态，“部分新品”',
  ]
}
export default productData;
